/* ============================================================
   VAPE FACULTY — AJAX CART
   Stays on page when adding to cart, shows toast notification
   ============================================================ */

(function () {

  /* ── Toast notification ── */
  function showToast(message, isError) {
    var existing = document.getElementById('vf-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'vf-toast';
    toast.textContent = message;
    toast.style.cssText = [
      'position:fixed',
      'bottom:28px',
      'right:28px',
      'z-index:99998',
      'padding:14px 22px',
      'border-radius:6px',
      'font-family:Rajdhani,sans-serif',
      'font-size:15px',
      'font-weight:600',
      'letter-spacing:.06em',
      'box-shadow:0 8px 32px rgba(0,0,0,.5)',
      'transition:opacity .3s ease, transform .3s ease',
      'opacity:0',
      'transform:translateY(12px)',
      isError
        ? 'background:#1a0a0a;color:#e53e3e;border:1px solid rgba(229,62,62,.4)'
        : 'background:#0a1a16;color:#2eb696;border:1px solid rgba(46,182,150,.4)'
    ].join(';');

    document.body.appendChild(toast);

    /* Animate in */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.style.opacity = '1';
        toast.style.transform = 'translateY(0)';
      });
    });

    /* Animate out after 3s */
    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(12px)';
      setTimeout(function () { toast.remove(); }, 320);
    }, 3000);
  }

  /* ── Update cart count badge in header ── */
  function updateCartCount(count) {
    var badge = document.querySelector('.cart-count');
    if (!badge) {
      /* Create badge if it doesn't exist yet */
      var cartIcon = document.querySelector('.cart-wrap');
      if (cartIcon && count > 0) {
        badge = document.createElement('span');
        badge.className = 'cart-count';
        cartIcon.appendChild(badge);
      }
    }
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  /* ── Intercept product form submission ── */
  function attachFormListeners() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.ajaxCart) return; /* Already attached */
      form.dataset.ajaxCart = '1';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var submitBtn = form.querySelector('[type="submit"]');
        var originalText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
        }

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Could not add to cart'); });
          return r.json();
        })
        .then(function (item) {
          /* Get updated cart for count */
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              showToast(item.title + ' added to cart ✓', false);
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
              }
            });
        })
        .catch(function (err) {
          showToast(err.message || 'Something went wrong', true);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
      });
    });
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachFormListeners);
  } else {
    attachFormListeners();
  }

  /* Re-run if new forms are added dynamically (variant changes etc) */
  var observer = new MutationObserver(function () { attachFormListeners(); });
  observer.observe(document.body, { childList: true, subtree: true });

})();
